<template>
  <div class="checkbox-accept-terms-container">
    <b-form-checkbox
      v-model="selected"
      :value="true"
      class="custom-control-primary"
    >
      Acepto los terminos referidos en la carta compromiso
    </b-form-checkbox>

    <a
      :href="filePath"
      target="_blank"
    >
      <strong>(ver carta compromiso)</strong>
    </a>
  </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'

export default {
  components: {
    BFormCheckbox,
  },
  setup(_, { emit }) {
    const delivery = process.env.VUE_APP_DELIVERY_DOWNLOAD
    const filePath = `${delivery}/publico/carta-compromiso/carta-compromiso.pdf`
    const selected = ref(false)

    watch(selected, value => {
      emit('on-value-change', value)
    })

    return { filePath, selected }
  },
}
</script>

<style scoped>
.checkbox-accept-terms-container {
  display: flex;
  gap: 5px;
}
</style>
